var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "curentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 12.25C20.25 11.8358 19.9142 11.5 19.5 11.5L6.31066 11.5L11.7803 6.03033C12.0732 5.73744 12.0732 5.26256 11.7803 4.96967C11.4874 4.67678 11.0126 4.67678 10.7197 4.96967L3.96967 11.7197C3.67678 12.0126 3.67678 12.4874 3.96967 12.7803L10.7197 19.5303C11.0126 19.8232 11.4874 19.8232 11.7803 19.5303C12.0732 19.2374 12.0732 18.7626 11.7803 18.4697L6.31066 13L19.5 13C19.9142 13 20.25 12.6642 20.25 12.25Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.f7f20d360ab6af15fd5860238275a27e.svg";
export { ForwardRef as ReactComponent };